module.exports = __webpack_public_path__ + "img/menu-dem-active.c84e2caf.svg";